import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-astcybersecurity',
  templateUrl: './astcybersecurity.component.html',
  styleUrls: ['./astcybersecurity.component.scss']
})
export class AstcybersecurityComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
